const initialState = {
  inputs: {
    bank_accounts: [],
    person_shareholder: [],
    person_directors: [],
    person_authorized: [],
    other_uploads: []
  },
  errors: {},
  isCancel: false,
  isSuccess: false,
  isSave: true,
  isSubmit: false,
  preview: true,
  isFinish: false,
  allPreview: false,
  isLoader: false,
  step: 1,
  lastStep: 1
}

export default (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case 'ON_CHANGE':
      return {
        ...state,
        inputs: {
          ...state.inputs,
          [payload.name]: payload.value
        }
      }
    case 'ON_PREVIEW_ACCOUNT':
      return {
        ...state,
        preview: payload
      }
    case 'ON_SAVE_ACCOUNT':
      return {
        ...state,
        isSave: payload
      }
    case 'ON_SUBMIT_ACCOUNT':
      return {
        ...state,
        isSubmit: !state.isSubmit
      }
    case 'ON_SET_ERROR':
      return {
        ...state,
        errors: {
          ...state.errors,
          [payload.name]: payload.value
        }
      }
    case 'ON_FINISH_ACCOUNT':
      return {
        ...state,
        isFinish: payload
      }
    case 'ON_SUCCESS_ACCOUNT':
      return {
        ...state,
        isSuccess: payload
      }
    case 'ON_ALL_PREVIEW_ACCOUNT':
      return {
        ...state,
        allPreview: !state.allPreview
      }
    case 'ON_CANCEL_ACCOUNT':
      return {
        ...state,
        isCancel: payload
      }
    case 'ON_LOADER_ACCOUNT':
      return {
        ...state,
        isLoader: payload
      }
    case 'ON_SET_ALL_FORM':
      return {
        ...state,
        inputs: payload
      }
    case 'ON_CLEAR_ACCOUNT':
      return initialState
    default:
      return state
  }
}
